import { LOGIN, LOGIN_JWT, UNIVERSITY, LOGOUT } from '~/consts';
import ONESIGNAL_MIXIN from "~/mixins/onesignal";

export default {
  mixins: [ONESIGNAL_MIXIN],

  data() {
    return {
      loading_login: false,
      use_siakad: false
    }
  },

  mounted() {
    if (window.OneSignal) {
      window.OneSignal.push(() => {
        if (!window.OneSignal.isPushNotificationsSupported()) {
          return;
        }

        window.OneSignal.isPushNotificationsEnabled((isEnabled) => {
          if (isEnabled === true) {
            window.OneSignal.setSubscription(true);
            this.setOneSignalPlayerId();
          } else {
            window.OneSignal.registerForPushNotifications();
            this.setOneSignalPlayerId();
          }
        });

        window.OneSignal.on("subscriptionChange", () => {
          this.setOneSignalPlayerId();
        });
      });
    }
  },

  methods: {
    setOneSignalPlayerId() {
      if (!this.isEmpty(this.user)) {
        window.OneSignal.getUserId((userId) => {
          this.user.web_reg_id = userId;
        });
      }
    },
    onLoginSuccess(data) {
      if (data.data.status == 'ACTIVE') {
        const token = data.data.userToken.token;
//      Success
        this.$store.commit('setToken', token);
        this.$cookies.set('token', token, {
          path: '/',
          expires: this.getDateOfTokenExpires(),
        });

        const redirect = this.$route.query.r
        if (!this.isEmpty(redirect)) {
          window.location.href = redirect
        } else {
          window.location.href = '/panel'
        }
      } else {
        this.$buefy.open({
          message: data.applicationSystem.message,
          type: 'is-info'
        });

        this.$router.push({ path: '/confirm', query: { email: postData.email } });
      }
    },
    onLoginFailed() {},
    onLoginJwtSuccess() {},
    onLoginJwtFailed() {},
    login(user) {
      const vm = this
      let eid = this.$cookies.get('_eid');
      let browser_info = null

      vm.loading_login = true;

      const postData = {
        username: user.username,
        app_id: user.app_id,
        email: user.email,
        password: user.password,
        web_reg_id: user.web_reg_id,
        device: JSON.stringify({
          secureId: eid,
          name: this.$ua._parsed.name,
          manufacture: this.$ua._parsed.vendor,
          model: this.$ua._parsed.name,
          product: this.$ua._parsed.name,
          hardware: this.$ua._parsed.os,
          version: this.$ua._parsed.version,
          regId: user.web_reg_id,
        })
      };

      if (this.use_siakad) {
        if (this.isEmpty(postData['app_id'])) {
          toast.danger('Silakan pilih nama perguruan tinggi sesuai yang tersedia')
          vm.loading_login = false;
          return;
        }

        if (this.isEmpty(postData['username'])) {
          toast.danger('Username harus diisi')
          vm.loading_login = false;
          return;
        }
      } else {
        if (this.isEmpty(postData['email'])) {
          toast.danger('Email harus diisi')
          vm.loading_login = false;
          return;
        }
      }

      if (this.isEmpty(postData['password'])) {
        toast.danger('Kata sandi harus diisi')
        vm.loading_login = false;
        return;
      }

  //    Execute Request
      this.$axios.post(LOGIN, postData).then(({ data }) => {
        let message = data.applicationSystem.message;

        if (data.applicationSystem.code == 0) {
          vm.onLoginSuccess(data)
        } else {
          vm.onLoginFailed(data)
  //        Failed
          this.$buefy.toast.open({
            message: message,
            type: 'is-danger'
          })
        }

        vm.loading_login = false;
      }).catch(() => {
        vm.onLoginFailed()
        vm.loading_login = false;
      });
    },
    loginJwt(user) {
      const vm = this
      let eid = this.$cookies.get('_eid');
      let browser_info = null

      vm.loading_login = true;

      const postData = {
        username: user.username,
        app_id: user.app_id,
        email: user.email,
        password: user.password,
        web_reg_id: user.web_reg_id
        // device: JSON.stringify({
        //   secureId: eid,
        //   name: this.$ua._parsed.name,
        //   manufacture: this.$ua._parsed.vendor,
        //   model: this.$ua._parsed.name,
        //   product: this.$ua._parsed.name,
        //   hardware: this.$ua._parsed.os,
        //   version: this.$ua._parsed.version,
        //   regId: user.web_reg_id,
        // })
      };

      if (this.use_siakad) {
        if (this.isEmpty(postData['app_id'])) {
          toast.danger('Silakan pilih nama perguruan tinggi sesuai yang tersedia')
          vm.loading_login = false;
          return;
        }

        if (this.isEmpty(postData['username'])) {
          toast.danger('Username harus diisi')
          vm.loading_login = false;
          return;
        }
      } else {
        if (this.isEmpty(postData['email'])) {
          toast.danger('Email harus diisi')
          vm.loading_login = false;
          return;
        }
      }

      if (this.isEmpty(postData['password'])) {
        toast.danger('Kata sandi harus diisi')
        vm.loading_login = false;
        return;
      }

  //    Execute Request
      this.$axios.post(LOGIN_JWT, postData).then(({ data }) => {
        let message = data.applicationSystem.message;

        if (data.applicationSystem.code == 0) {
          vm.onLoginJwtSuccess(data)
        } else {
          vm.onLoginJwtFailed(data)
  //        Failed
          this.$buefy.toast.open({
            message: message,
            type: 'is-danger'
          })
        }

        vm.loading_login = false;
      }).catch(() => {
        vm.onLoginJwtFailed()
        vm.loading_login = false;
      });
    },

    logout() {
      const cookies = this.$cookies;

      this.$axios.post(LOGOUT, {}).then(({ data }) => {
        this.$store.commit('clearAuth');
        this.$store.commit('clearToken');
        this.$store.commit('resetState');
        this.$store.commit('universities/resetUniversitiesState');
        cookies.remove('token');
        let token_temp = cookies.get('token_temp');

        if (!helpers.isEmpty(token_temp)) {
          this.$store.commit('setToken', token_temp);
          cookies.set('token', token_temp);
          cookies.remove('token_temp');

          window.location.href = '/login';
        } else {
          window.OneSignal.setSubscription(false);
          this.$router.push('/login')
        }
      }).catch(() => {
        this.$store.commit('clearAuth');
        this.$store.commit('clearToken');
        this.$store.commit('resetState');
        this.$store.commit('universities/resetUniversitiesState');
        cookies.remove('token');

        this.$router.push('/login')
      });
    }
  }
}
